/**
 * Shared domain validation patterns for organization domains
 */

/**
 * Domain validation pattern for organization subdomains
 *
 * Pattern breakdown:
 * - ^[a-z0-9]              : Must start with lowercase letter or digit
 * - (?:                    : Non-capturing group for middle characters
 *     [a-z0-9]             :   - Either a lowercase letter or digit
 *     |                    :   - OR
 *     -(?=[a-z0-9])        :   - A hyphen only if followed by letter/digit (prevents trailing/consecutive hyphens)
 *   )*                     : Repeat middle group zero or more times
 * - [a-z0-9]$              : Must end with lowercase letter or digit
 *
 * Rules enforced:
 * - Minimum 2 characters (enforced by the regex itself) - single-character domains are rejected by the pattern
 * - Lowercase alphanumeric with hyphens only
 * - No consecutive hyphens, no hyphens at start/end
 * - Note: ORG_DOMAIN_MIN_LENGTH constant should match the regex minimum length
 */
export const ORG_DOMAIN_PATTERN =
  /^[a-z0-9](?:[a-z0-9]|-(?=[a-z0-9]))*[a-z0-9]$/

/**
 * Minimum length requirement for organization domains
 */
export const ORG_DOMAIN_MIN_LENGTH = 2

/**
 * Domain validation pattern for root domains (e.g., example.com)
 * - Lowercase alphanumeric with hyphens only
 * - Each segment: 1-63 characters, no hyphens at start/end
 * - Must have at least one dot and valid TLD (2-63 chars)
 */
export const ROOT_DOMAIN_PATTERN =
  /^([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]{2,63}$/
